import { OutputEmitterRef } from '@angular/core';
import { ActionTypeHandlerBaseSmartEnum, ActionTypeHandlerEnum } from '.';
import { IBaseActionConfig, IActionExecutedEvent } from '../../types';

export interface ICustomExecutorActionConfig<TEntity> extends IBaseActionConfig<ICustomExecutorHandlerConfig<TEntity>> {
  handlerType: ActionTypeHandlerEnum.CUSTOM_EXECUTOR;
}

export interface ICustomExecutorHandlerConfig<TEntity> {
  execute: (item?: TEntity, actionExecuted?: OutputEmitterRef<IActionExecutedEvent<TEntity>>) => void;
}

export class CustomExecutorActionTypeHandlerSmartEnum extends ActionTypeHandlerBaseSmartEnum {
  public static CustomExecutor = new CustomExecutorActionTypeHandlerSmartEnum(ActionTypeHandlerEnum.CUSTOM_EXECUTOR);

  constructor(name: string) {
    super(name);
  }

  override execute<TEntity>(
    { handlerConfig: config }: ICustomExecutorActionConfig<TEntity>,
    item?: TEntity,
    actionExecuted?: OutputEmitterRef<IActionExecutedEvent<TEntity>>
  ): void {
    if (!config.execute) {
      throw new Error(`Custom executor handler requires a valid function to execute`);
    }

    config.execute(item, actionExecuted);
  }
}
